import React from 'react';
import Checkbox from 'src/components/Checkbox';
import { ITableColumn } from 'src/components/Table/types';

interface Suite {
  id: string;
  number: string;
  status: string;
  areas: Array<{ name: string }>;
  homeOwners: {
    firstname: string | null;
    lastname: string | null;
  };
}

interface CreateSuiteTableColumnsParams {
  allSelected: boolean;
  onSelectAll: () => void;
  selectedSuiteIds: string[];
  onSuiteSelect: (suiteId: string) => void;
}

const getHomeOwnerName = (homeOwner: {
  firstname: string | null;
  lastname: string | null;
}) => {
  if (!homeOwner.firstname && !homeOwner.lastname) {
    return 'No Owner';
  }
  return `${homeOwner.firstname || ''} ${homeOwner.lastname || ''}`.trim();
};

export const createSuiteTableColumns = ({
  allSelected,
  onSelectAll,
  selectedSuiteIds,
  onSuiteSelect,
}: CreateSuiteTableColumnsParams): ITableColumn[] => {
  return [
    {
      label: <Checkbox readOnly value={allSelected} onChange={onSelectAll} />,
      style: { width: '5rem' },
      cell: (data: Suite) => (
        <Checkbox
          checked={selectedSuiteIds.includes(data.id) || allSelected}
          name={data.id}
          value={selectedSuiteIds.includes(data.id) || allSelected}
          onChange={() => onSuiteSelect(data.id)}
          readOnly
        />
      ),
    },
    {
      label: 'Suite #',
      accessor: 'number',
      sortable: true,
      style: { width: '8rem' },
    },
    {
      label: 'Status',
      accessor: 'status',
      sortable: true,
      style: { width: '5rem' },
      cell: (data: Suite) => data.status,
    },
    {
      label: 'Areas',
      sortable: true,
      style: { width: '10rem' },
      cell: (data: Suite) =>
        `${data.areas.length} room${data.areas.length !== 1 ? 's' : ''}`,
      sortingAlgorithm: (a: Suite, b: Suite) => a.areas.length - b.areas.length,
    },
    {
      label: 'Home Owner',
      sortable: true,
      style: { width: '12rem' },
      cell: (data: Suite) => getHomeOwnerName(data.homeOwners),
      sortingAlgorithm: (a: Suite, b: Suite) => {
        const nameA = getHomeOwnerName(a.homeOwners);
        const nameB = getHomeOwnerName(b.homeOwners);
        return nameA.localeCompare(nameB);
      },
    },
  ];
};
